import { useEffect, useState } from "react";
import { Figure } from "../Figure";
import { LetterDialog } from "../LetterDialog";
import { LEADERSHIP_MESSAGES as SLIDES } from "../../lib/leadershipMessages";

/**
 * The three letters here are the same ones the About page prints in its
 * single "Leader's Message" section — same portrait, same pull quote, same
 * paragraphs, sourced from lib/leadershipMessages.ts. Kept in step
 * deliberately: the home page is the short form of that section, not a
 * second draft of it. Edit the shared source, not either page.
 */
const ROTATION_MS = 8000;

export function DirectorMessage() {
  const [active, setActive] = useState(0);
  const [letterOpen, setLetterOpen] = useState(false);

  useEffect(() => {
    if (letterOpen) return;
    const t = window.setInterval(
      () => setActive((i) => (i + 1) % SLIDES.length),
      ROTATION_MS,
    );
    return () => window.clearInterval(t);
  }, [letterOpen]);

  const slide = SLIDES[active];

  return (
    <section className="section section-navy director-section leadership-section">
      <div className="container">
        {/* The house section head every other home section uses: kicker and
            title left, the section's control on the right where they put their
            "Explore campus →" link. Replaces a rounded pill that led the
            section with no heading above it. */}
        <div className="section-head leadership-head">
          <div>
            <div className="kicker">Leadership</div>
            <h2>Messages from the leadership.</h2>
          </div>
          <div className="leadership-tabs" role="tablist" aria-label="Leadership messages">
            {SLIDES.map((s, i) => (
              <button
                key={s.id}
                role="tab"
                aria-selected={i === active}
                aria-controls={`leadership-panel-${s.id}`}
                className={"leadership-tab" + (i === active ? " is-active" : "")}
                onClick={() => setActive(i)}
              >
                {s.role.split(" · ")[0]}
              </button>
            ))}
          </div>
        </div>

        <div
          key={slide.id}
          id={`leadership-panel-${slide.id}`}
          role="tabpanel"
          className="director-grid leadership-panel"
        >
          <div className="director-photo">
            {/* Without `sizes` the browser assumes 100vw and fetches a far
                larger portrait than the box ever shows. The box is capped at
                320px above 900px and 220px below it (home.css / mobile.css). */}
            <Figure
              media={slide.photo}
              fallbackLabel={slide.photoLabel}
              aspect="3/4"
              sizes="(max-width: 900px) 220px, 320px"
            />
            <div className="director-card">
              <div className="director-name">{slide.name}</div>
              <div className="director-role">{slide.role}</div>
            </div>
          </div>
          <div>
            <div className="kicker leadership-kicker">{slide.kicker}</div>
            <h2 className="leadership-quote">"{slide.quote}"</h2>
            {slide.body.map((t, i) => (
              <p key={i} className="leadership-body">{t}</p>
            ))}
            {slide.full && (
              <button
                type="button"
                className="letter-more"
                onClick={() => setLetterOpen(true)}
              >
                Read the full message <span aria-hidden>→</span>
              </button>
            )}
          </div>
        </div>

      </div>

      {slide.full && (
        <LetterDialog
          open={letterOpen}
          onClose={() => setLetterOpen(false)}
          kicker={slide.kicker}
          headline={slide.quote}
          paragraphs={slide.full}
          name={slide.name}
          role={slide.role}
          photo={slide.photo}
          photoLabel={slide.photoLabel}
        />
      )}
    </section>
  );
}
